/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per reaction (µL)`)
};

const es_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por reacción (µL)`)
};

const de_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Reaktion (µL)`)
};

const nl_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per reactie (µL)`)
};

const fr_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par réaction (µL)`)
};

const it_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per reazione (µL)`)
};

const pt_br2_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por reação (µL)`)
};

const pt_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por reação (µL)`)
};

const ja_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1反応あたり(µL)`)
};

const zh_pcr_per_rxn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每反应用量（µL）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_per_rxn = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_per_rxn(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_per_rxn", locale)
	if (locale === "en") return en_pcr_per_rxn(inputs)
	if (locale === "es") return es_pcr_per_rxn(inputs)
	if (locale === "de") return de_pcr_per_rxn(inputs)
	if (locale === "nl") return nl_pcr_per_rxn(inputs)
	if (locale === "fr") return fr_pcr_per_rxn(inputs)
	if (locale === "it") return it_pcr_per_rxn(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_per_rxn(inputs)
	if (locale === "pt") return pt_pcr_per_rxn(inputs)
	if (locale === "ja") return ja_pcr_per_rxn(inputs)
	return zh_pcr_per_rxn(inputs)
};